import { Switch } from "react-router-dom";

import ConciliacaoBancaria from "../../pages/financeiro/conciliacaobancaria/ConciliacaoBancaria";
import ConciliacaoUpload from "../../pages/financeiro/conciliacaobancaria/ConciliacaoUpload";
import ContasPagar from "../../pages/financeiro/contaspagar/ContasPagar";
import ContasReceber from "../../pages/financeiro/contasreceber/ContasReceber";
import FluxoDeCaixa from "../../pages/financeiro/fluxodecaixa/FluxoDeCaixa";
import NfeEmissao from "../../pages/financeiro/nfe/NfeEmissao";
import NfePainel from "../../pages/financeiro/nfe/NfePainel";
import { EmissaoContextProvider } from "../../pages/financeiro/nfe/contexts/EmissaoContext";
import { MinClienteContextProvider } from "../../pages/financeiro/nfe/contexts/MinClienteContext";
import { PainelNfeContextProvider } from "../../pages/financeiro/nfe/contexts/PainelNfeContext";
import { ParametrosProdutoContextProvider } from "../../pages/financeiro/nfe/contexts/ParametrosProdutoContext";
import RankingCliente from "../../pages/financeiro/rankingcliente/RankingCliente";
import ResultadoExercicio from "../../pages/financeiro/resultadoexercicio/ResultadoExercicio";
import Route from "../Route";

export default function Financeiro() {
  return (
    <>
      <EmissaoContextProvider>
        <ParametrosProdutoContextProvider>
          <MinClienteContextProvider>
            <PainelNfeContextProvider>
              <Switch>
                <Route path="/financeiro/nfe/emissao" component={NfeEmissao} />
                <Route path="/financeiro/nfe/painel" component={NfePainel} />
              </Switch>
            </PainelNfeContextProvider>
          </MinClienteContextProvider>
        </ParametrosProdutoContextProvider>
      </EmissaoContextProvider>

      <Switch>
        <Route path="/financeiro/conciliacao" component={ConciliacaoBancaria} />
        <Route
          path="/financeiro/conciliacaoupload"
          component={ConciliacaoUpload}
        />

        <Route path={"/financeiro/fluxo"} component={FluxoDeCaixa} />
        <Route path={"/financeiro/re"} component={ResultadoExercicio} />
        <Route path={"/financeiro/pagar"} component={ContasPagar} />
        <Route path={"/financeiro/receber"} component={ContasReceber} />
        <Route path={"/financeiro/ranking"} component={RankingCliente} />
      </Switch>
    </>
  );
}
